import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import Toggle from 'react-toggle';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class DesignationsAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.locale = getLocale();

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      name: null,
      initials: null,
      type: null,
      priority: null,
      role: null,
      equip_chief: 0,
      type_list: [
        {value: 1, label: this.locale.Designacoes.AdicionarDesignacao.opcoesTipos.Comum},
        {value: 2, label: this.locale.Designacoes.AdicionarDesignacao.opcoesTipos.Instrutor},
        {value: 3, label: this.locale.Designacoes.AdicionarDesignacao.opcoesTipos.Examinador},
      ],
      role_list: [
        {value: 'captain', label: this.locale.Designacoes.AdicionarDesignacao.opcoesCargos.Comandante},
        {value: 'copilot', label: this.locale.Designacoes.AdicionarDesignacao.opcoesCargos.Copiloto},
        {value: 'flight_attendant', label: this.locale.Designacoes.AdicionarDesignacao.opcoesCargos.Comissario},
      ],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2});
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    }
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      name: this.state.name,
      initials: this.state.initials,
      type: this.state.type,
      priority: this.state.priority,
      role: this.state.role,
      equip_chief: this.state.equip_chief,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/designacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/designacao/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        }
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Designacoes.AdicionarDesignacao.titulo}</h3>
      <Link to="/designacoes" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder="" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.Iniciais}:</label>
              <input type="text" name="initials" className="form-control" placeholder="" value={this.state.initials} onChange={this.handleChange.bind(this, 'initials')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Designacoes.AdicionarDesignacao.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.type_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.Funcao}:</label>
              <Select
                className="form-field-name"
                name="role"
                value={this.state.role}
                searchable={true}
                placeholder={this.locale.Designacoes.AdicionarDesignacao.formulario.placeholder.SelecionarFuncao}
                onChange={this.handleSelectChange.bind(this, 'role')}
                options={this.state.role_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.Prioridade}:</label>
              <input type="number" name="priority" className="form-control" placeholder="" value={this.state.priority} onChange={this.handleChange.bind(this, 'priority')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Designacoes.AdicionarDesignacao.formulario.ChefeDeEquipamento}:</label>
              <br/>
              <Toggle
                checked={this.state.equip_chief}
                aria-label='No label tag'
                name="equip_chief"
                onChange={this.handleToggleChange.bind(this, 'equip_chief')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Designacoes.AdicionarDesignacao.formulario.botaoAdicionarDesignicao}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default DesignationsAdd;



// WEBPACK FOOTER //
// ./src/Components/Designations/DesignationsAdd.js